<template>
  <v-app class="disable-favorites">
    <router-view />
    <err-dialog />
  </v-app>
</template>

<script>
import dialog from "./dialog.vue";
import "moodleDir/procollege/lib/style/styleTabs.css";
export default {
  name: "App",
  components: {
    "err-dialog": dialog,
  },
  created() {},
};
</script>
<style lang="scss">
#procollege_vue {
  .v-application--wrap {
    min-height: 100px !important;
  }
  /**
  secondary-navigation 60px default, даже если пустая
  */
  .moremenu {
    height: auto;
  }
  /**
  * цвет текста у кнопок/списков, etc перебивает тема moodle, в vuetify 4 !important 
  * больше не используется
  */
  .v-btn.bg-primary {
    background-color: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
  }

  .text-warning {
      color: rgb(var(--v-theme-warning)) !important;
  }
}
</style>
